// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { injectStripe, CardElement } from 'react-stripe-elements';
import { Button } from 'react-bootstrap';
import styled from 'styled-components';

const StyledCardElement = styled(CardElement)`
  padding: 10px;
  border: 1px solid #ccc;
`;

const StyledSubmitButton = styled(Button)`
  margin: 20px 0;
`;

const StyledStatusMessage = styled.span`
  display: block;
  font-size: 14px;
  color: #008000;
  margin: 10px 0;
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const CardForm = ({ stripe, setVerifiedCard, setIsLoading, verifiedCard }) => {
  const handleSubmit = async event => {
    event.preventDefault();
    try {
      setIsLoading(true);
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      const token = await stripe.createToken({ name: 'BAT card' });
      setVerifiedCard(token);
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <StyledCardElement style={{ base: { fontSize: '18px' } }} />
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {verifiedCard && !verifiedCard.error && (
        <StyledStatusMessage>Verified.</StyledStatusMessage>
      )}
      <StyledSubmitButton type='submit'>Verify Card</StyledSubmitButton>
    </form>
  );
};

export default injectStripe(CardForm);
